import { render, staticRenderFns } from "./callbackrecordtable.vue?vue&type=template&id=345abcd4&scoped=true&"
import script from "./callbackrecordtable.vue?vue&type=script&lang=js&"
export * from "./callbackrecordtable.vue?vue&type=script&lang=js&"
import style0 from "./callbackrecordtable.vue?vue&type=style&index=0&id=345abcd4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345abcd4",
  null
  
)

export default component.exports